/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLabelImportant = createReactComponent("outline", "label-important", "IconLabelImportant", [["path", { "d": "M16.52 7h-12.52l4 5l-4 5h12.52a1 1 0 0 0 .78 -.375l3.7 -4.625l-3.7 -4.625a1 1 0 0 0 -.78 -.375", "key": "svg-0" }]]);

export { IconLabelImportant as default };
//# sourceMappingURL=IconLabelImportant.mjs.map
